/* src/app/home-new/options-button/options-button.component.scss */
.containerDiv {
  border-radius: 20px;
  padding: 10px 10px;
  background: var(--Blanco-y-negro-GRIS-1, #f6f6f6) !important;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.15) !important;
  margin-top: 10px;
  margin-right: 20px;
}
.containerDiv .title {
  color: #949494;
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  font-family: "Barlow Semi Condensed", sans-serif;
  text-wrap: pretty;
  display: flex;
  align-items: center;
}
.containerDiv .tooltip-icon {
  color: gray;
  width: 20px;
  height: 20px;
  z-index: 99;
  cursor: pointer;
  margin-left: auto;
}
.containerDiv .category-title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #f5b200;
  text-transform: uppercase;
  width: 200%;
}
.containerDiv .category-title.w-100 {
  width: 100% !important;
}
@media (max-width: 700px) {
  .containerDiv .category-title {
    display: none !important;
  }
}
.containerDiv ion-button {
  --border-width: 1px;
  --background-activated: #cbcbcb3a;
  --background-color: #37373e;
  --background: #fff;
  border-radius: 15px;
  margin: 0;
  padding: 2px 0px;
}
.containerDiv ion-button .image-option {
  color: gray;
  min-height: 42px;
  min-width: 28px;
  margin-right: 5px;
}
.containerDiv ion-button .title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
  font-family: "Barlow Semi Condensed", sans-serif;
  text-wrap: pretty;
}
.containerDiv ion-button .sub-title {
  color: #949494;
  font-size: 16px;
  font-weight: 400;
  font-family: "Barlow Semi Condensed", sans-serif;
  text-wrap: balance;
}
.containerDiv ion-button::part(native) {
  padding: 9px;
  border: 1px solid #cbcbcb;
}
.containerDiv ion-button:hover::part(native) {
  --background-hover: #fff !important;
  border: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
}
.containerDiv ion-button.selected {
  --border-width: 2px;
}
.containerDiv ion-button.selected.finishing-selected::part(native),
.containerDiv ion-button.selected.finishing-selected:hover::part(native),
.containerDiv ion-button.selected.finishing-selected:focus::part(native) {
  border-color: var(--ion-color-secondary);
  background-color: #fff0c6;
  --background-hover: #fff0c6 !important;
  --background-activated: #fff0c6 !important;
  box-shadow: 2px 2px 2px 2px rgba(245, 178, 0, 0.3);
  border: 2px solid #f5b200;
}
.containerDiv ion-button.selected.general-selected::part(native) {
  background-color: #d4ecff;
  --background-hover: #43c0f60d;
  --background-activated: #43c0f60d;
  box-shadow: 0 2px 15px 0 rgba(67, 192, 246, 0.3);
  border: 1px solid var(--Colores-secundarios-CIAN-OSCURO, #259dff);
}
.containerDiv ion-button.general-selected .image-option {
  transform: scale(1.5);
}
.containerDiv .option-tooltip-wrapper {
  position: relative;
}
.containerDiv .option-tooltip-wrapper.with-badge {
  padding-top: 22px;
}
.containerDiv .option-badge {
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  background: var(--ion-color-danger);
  color: #fff;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  white-space: nowrap;
  padding: 6px 14px;
  border-radius: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
.containerDiv .option-margin-bottom {
  margin-bottom: 8px;
}
.containerDiv .info-button button {
  padding: 0 !important;
}
.containerDiv ng-lottie {
  width: 50px;
  margin-left: 7px;
  filter: brightness(0) invert(0) !important;
}
.note {
  width: 100%;
  font-size: 16px;
  color: rgb(255, 255, 255);
  text-align: center;
  font-style: italic;
  margin-bottom: 5px;
}
.binding-options-container {
  border: 1px solid #949494;
  border-radius: 20px;
  padding: 10px;
  width: 100%;
  box-shadow: 0 0 20px 0 rgba(245, 178, 0, 0.4);
  background-color: #f6f6f6 !important;
}
.binding-options-container ion-button {
  border-color: var(--ion-color-secondary);
}
.binding-options-container ion-segment {
  background: #f4f4f4;
  border-radius: 10px;
  padding: 8px;
}
.binding-options-container ion-segment ion-segment-button {
  padding: 5px 0;
}
.binding-options-container ion-segment ion-segment-button::part(indicator-background) {
  border-radius: 8px;
  background: #d9f2fd;
}
.binding-options-container ion-segment ion-label {
  font-size: 20px;
}
.binding-options-container .segment-selection {
  padding: 10px 0 15px 0;
  text-align: center;
}
.binding-options-container .segment-selection span {
  font-size: 18px;
  font-weight: 600;
}
.binding-options-container img {
  width: 50px;
}
.binding-options-container .selection {
  padding: 4px;
  cursor: pointer;
}
.binding-options-container .selection.selected {
  border-radius: 10px;
}
@media (max-width: 412px) {
  .containerDiv .title {
    font-size: 18px;
  }
  .containerDiv ion-button .title {
    font-size: 14px;
  }
  .containerDiv ion-button .sub-title {
    font-size: 12px;
  }
}
.bindingWarning {
  border: 2px solid #f5b200;
  background-color: #fff9e8;
  border-radius: 15px;
  padding: 10px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  width: 100%;
  margin-bottom: 10px;
  text-align: start;
}
.bindingWarning p {
  width: 100%;
  color: #f5b200;
}
@media (max-width: 400px) {
  .bindingWarning p {
    font-size: 12px;
  }
}
.toggle {
  --border-radius: 25px;
  border-radius: 25px;
  border: 1px solid #949494;
  box-shadow: 0px 2px 2px -1px rgba(49, 49, 48, 0.1) inset;
}
.button-popover-container {
  position: relative;
  display: inline-block;
}
.containerDiv .tooltip-icon,
.binding-options-container .tooltip-icon {
  color: #949494 !important;
  fill: #949494 !important;
}
.containerDiv.finishing {
  box-shadow: none !important;
  background: none !important;
}
::ng-deep .containerDiv .title-black {
  color: black !important;
}
::ng-deep ion-toggle.toggle {
  --background: #f6f6f6 !important;
  --background-checked: #f6f6f6 !important;
  --track-background: #f6f6f6 !important;
  --track-background-checked: #43c0f6 !important;
  --border-radius: 25px !important;
  border-radius: 25px !important;
  border: 1.5px solid #949494 !important;
  box-shadow: none !important;
  --handle-background: #c4c4c4 !important;
  --handle-background-checked: #fff !important;
  --handle-border-radius: 50% !important;
  --handle-box-shadow: none !important;
  --handle-spacing: 2px !important;
  --border-width: 2px !important;
  --handle-width: 24px !important;
  --handle-height: 24px !important;
}
/*# sourceMappingURL=options-button.component-RUYR2Y5U.css.map */
